import React, {FC} from "react"
import styled from "styled-components"

import MenuLink from "./MenuLink"
import Icon from "./styled/Icon"

const StyledMenuLink = styled(MenuLink)`
  display: flex;
  justify-content: space-between;
`

interface Props {
  to: string
}

const MenuLinkRight: FC<Props> = ({children, ...props}) => (
  <StyledMenuLink {...props}>
    <span>{children}</span>
    <Icon icon="angleRight" />
  </StyledMenuLink>
)

export default MenuLinkRight
